import React from 'react'
import ListItemText from '@mui/material/ListItemText'
import ListItem, { ListItemProps } from '@mui/material/ListItem'
import { Stack, Typography } from '@mui/material'

interface MenuItemProps extends ListItemProps {
  name?: string
}

export const MenuItem = ({ name, children, ...props }: React.PropsWithChildren<MenuItemProps>) => {
  return (
    <ListItem disablePadding {...props}>
      <ListItemText
        primary={
          <Stack direction='row' gap={0.5} sx={{ width: '100%' }}>
            {name && <Typography>{name}</Typography>}
            <Typography sx={{ wordBreak: 'break-word', overflowWrap: 'anywhere', whiteSpace: 'normal', flex: 1 }}>{children}</Typography>
          </Stack>
        }
      />
    </ListItem>
  )
}
